export default __webpack_public_path__ + "static/ngrzybek-7da9ff620f38fb44b799e9bf3b0bc111.png";